import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsEditMod, selectIsUndoModal, selectStandard } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { dataSorting, findKeyBaseOnValue, formatTypeAheadOptions } from '../../ModificationsUtils';

interface ShortHoursTypeProps {
  readOnly?: boolean;
}

export const ShortHoursType = ({ readOnly }: ShortHoursTypeProps) => {
  const { control, getValues, setValue, clearErrors, setError, register } = useFormContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isUndoModal = useSelector(selectIsUndoModal);
  const shortHoursType = 'shortHoursType';
  register('bonusShortHoursTypeId');
  const isModEdit = useSelector(selectIsEditMod);
  const standard = useSelector(selectStandard);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const [bonusShortHourTypeOptions, setBonusShortHourTypeOption] = useState([]);

  const getBonusShortHourTypeDropDown = async () => {
    const options = await getSearchFilterOptions('bonusShortHoursType');

    if (options?.length > 0) {
      const newOptions = formatTypeAheadOptions(options);
      setBonusShortHourTypeOption(newOptions);

      if (getValues(shortHoursType)) {
        const selectedOption = findKeyBaseOnValue(newOptions, getValues(shortHoursType));

        setValue('bonusShortHoursTypeId', selectedOption?.id);
        clearErrors(shortHoursType);
      } else {
        setError(shortHoursType, {});
      }
      if (isUndoModal) {
        dispatch(placementModsAction.setIsUndoModal(false));
      }
    }
  };

  const getShortHoursId = (value: string) => {
    const selectedOption = findKeyBaseOnValue(bonusShortHourTypeOptions, value);
    return selectedOption?.id;
  };

  const onSelectionChange = (value?: string) => {
    setValue(shortHoursType, value);
    setValue('bonusShortHoursTypeId', getShortHoursId(value));
    if (value) {
      clearErrors(shortHoursType);
    }
  };

  useEffect(() => {
    getBonusShortHourTypeDropDown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal]);

  return (
    <Controller
      control={control}
      name={shortHoursType}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <FormInputDropdown
          useMenuItem={true}
          name={shortHoursType}
          label={`${t('placement.placementMods.shortHourType')} *`}
          standard={true}
          options={dataSorting(bonusShortHourTypeOptions) ?? []}
          handleChange={e => {
            onSelectionChange(e.target.value);
            onChange(e.target.value);
          }}
          {...rest}
          inputValue={getValues(shortHoursType) ?? ''}
          readOnly={readOnly !== undefined ? readOnly : (standard ? true : !isModEdit)}
          disabled={isSaveModApiCalling}
        ></FormInputDropdown>
      )}
    />
  );
};
